import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HttpClient } from './http.service';
import { Logger } from '../logging/default-log.service';
import { BarcodeProduct } from '../classes/barcode.product';
import { ConfigurationHelper } from '../helper/configuration.helper';

@Injectable()
export class BarcodeScannerService extends BaseService {
  constructor(
    private http: HttpClient,
    logger: Logger
  ) {
    super(logger);
  }

  getBarcodeProduct(barcode: string): Observable<BarcodeProduct> {
    let url = ConfigurationHelper.getWebshopUrl('/rest/barcode/product');

    if (barcode !== null) {
      url += `?barcode=${barcode}`;
    }

    return this.http
      .get<BarcodeProduct>(url)
      .pipe(catchError(this.handleError));
  }
}
